import { PAYER_SIGNATURE_OPTION_VALUES } from './payerSignatureOptions';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';


export const payerSignatureOptionToPayerSignature = (option: SelectOption) => {
  if (option.value === PAYER_SIGNATURE_OPTION_VALUES.ORG_DEFAULT) {
    return null;
  }

  return option.value === PAYER_SIGNATURE_OPTION_VALUES.YES;
};
